// src/utils/constants/colors

const colors = {
  // Brand gradient colors - consistent with navbar logo
  primary: "#3b82f6", // Brand primary blue
  primaryEnd: "#6366f1", // Brand gradient end color
  primaryGradient: "linear-gradient(135deg, #3b82f6 0%, #6366f1 100%)", // Brand gradient
  primaryHover: "#2563eb", // Darker blue for hover states
  primaryLight: "#eff6ff", // Light blue for backgrounds and focus rings
  
  // Legacy support (will be phased out)
  primaryDarker: "#2563eb", // Maps to primaryHover

  secondary: "#FFB74D", // Light orange for accent (optional for calls to action)
  greyLight: "#e0e0e0", // Very light grey for backgrounds and subtle borders
  greyDark: "#333", // Dark grey for text and icons
  greyMedium: "#8f8f8f",
  white: "#FFFFFF", // Clean white for contrast
};

export default colors;
